import { Props } from "./ReactVideoPlayer"

export const mockProps: Props = {
  url: "https://stream.mux.com/D3BadPx005iere3FsHIjAo00tnairHfahC02e5Uhs8eEPo.m3u8",
}
